import {
  BoomFinanceVerificationSettings,
  VerificationNames
} from "shared/types";
import { ReportHeader } from "views/applications-id-report/components/ReportHeader";

import { PurchaseApplicationReport } from "./types";
import { ApplicationSlice } from "./slices/ApplicationSlice";
import { SelectedLendersSlice } from "./slices/SelectedLendersSlice";
import { LoanDetailsSlice } from "./slices/LoanDetailsSlice";
import { HomeDetailsSlice } from "./slices/HomeDetailsSlice";
import { BorrowersSlice } from "./slices/BorrowersSlice";
import { DeclarationsSlice } from "./slices/DeclarationsSlice";
import { EConsentSlice } from "./slices/EConsentSlice";

/**
 * Presentational composition of the purchase-application report. Kept free of
 * data fetching so the container (`index.tsx`) can feed it live verification
 * data, while the dev-debug harness feeds it the mock.
 */
export const PurchaseApplicationReportBody = ({
  report,
  settings
}: {
  report: PurchaseApplicationReport;
  settings?: BoomFinanceVerificationSettings;
}) => (
  <>
    <ReportHeader
      title="Purchase application"
      name={VerificationNames.BoomFinanceVerification}
      reportDate={report.submittedAt || report.lastUpdatedAt}
    />

    <ApplicationSlice report={report} />
    <SelectedLendersSlice lenders={report.lenders} />
    <LoanDetailsSlice
      loan={report.purchaseInfo}
      settings={settings?.loan_details}
    />
    <HomeDetailsSlice
      loan={report.purchaseInfo}
      settings={settings?.home_details}
    />
    <BorrowersSlice borrowers={report.borrowers} />
    <DeclarationsSlice declarations={report.declarations} />
    <EConsentSlice consents={report.consents} lenders={report.lenders} />
  </>
);
